import { render, staticRenderFns } from "./UnsynchronizedFormatListView.vue?vue&type=template&id=0b1cd6c6&scoped=true&"
import script from "./UnsynchronizedFormatListView.vue?vue&type=script&lang=ts&"
export * from "./UnsynchronizedFormatListView.vue?vue&type=script&lang=ts&"
import style0 from "./UnsynchronizedFormatListView.vue?vue&type=style&index=0&id=0b1cd6c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1cd6c6",
  null
  
)

export default component.exports